export default __webpack_public_path__ + "static/media/android.acb7bd82.png";